import React, { useEffect } from 'react'
import {Link} from 'react-router-dom';
import foundimage from '../Assets/Images/found.jpg';
import Foundationcarousel from '../Screen/Foundationcarousel';
import { BASE_URL } from '../Config/Base';

const FoundationdashboardMain =()=> {
  const token = JSON.parse(localStorage.getItem('usertoken'));

    useEffect(()=>{

    fetchgetmethod();
    getRole();
    getAssignUser();
     
    })

  function fetchgetmethod(){
 
    console.log("Token", token)
    
    fetch(`${BASE_URL}/Foundation/Getfoundationusers`, {
  
      method: 'GET',
  
      headers: {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
        "Authorization": "Bearer " + `${token}`,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  
      },
  
      //body:JSON.stringify(data)
  
    }).then(response => response.json())
         
  
      .then(data => {
        console.log("Data", data)
        
        //setAllusers(data);
        //  setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        localStorage.setItem("paginationData", JSON.stringify(data));    
      }
      );
  

    }
     
    function getRole(){


      fetch(`${BASE_URL}/Foundation/FoundationGetRoles`, {
        method:'GET',
  
      headers : {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
        "Authorization": "Bearer " +`${token}`,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },
  
  
      })
  
            .then(response => response.json())
  
  
              .then(data => {
               console.log("Role",data)
               //setRoletable(data)
                localStorage.setItem("paginationDataRole", JSON.stringify(data));
             
              });

          }

          
      function getAssignUser(){
  
        fetch(`${BASE_URL}/Foundation/GetAssignUsers`, {
          method:'GET',
          headers : {
    
            "Content-type": "application/json",
    
            "Accept": "application/json",
      
            "Authorization": "Bearer " + `${token}`,
      
            "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
          },
    
          //body:JSON.stringify(data)
    
        }).then(response => response.json())
        .then(data => {
          console.log("Data",data)
          //setAssigndetails(data);
          // setpaginatedPosts(_(data).slice(0).take(pageSize).value());
          //localStorage.setItem("SectionData", JSON.stringify(data));
          localStorage.setItem("paginationDataAssign", JSON.stringify(data));
        });
      
      }
    
  

  return (
        
    <div className='foundation-addmain'>
    <div className="foundation-addgrid-layout">
    <div className="foundation-addmain-top">
    <div className='foundation-addmain-back'>
    <Link to='/Kdp Foundation'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
    </div> 
    <span>WELCOME TO KDP FOUNDATION</span>
    </div>
    </div>

    <div className='found-heading'><h4>Introduction</h4></div>
    <br></br>

     <div className='found-para'><p1>KDP Foundation was founded on 10/10/2013. We are registered 12AA and 80G of income tax act 1961 and have been approved by the commissioner of income tax, Bengaluru No#CIT(E)BLR/80G/2017-18/10109 dated July 24th, 2017. Donations made to the trust are elgible for deduction under section 80G as specified under the income tax act 1961 and rules applicable from time to time.</p1>
     </div>
      <br></br>
      <br></br>

     <div className='found-image'>
     <img src={foundimage} alt="logo"/>
     </div>
     <br></br>
     <br></br>
     <br></br>

    <div className='text-center'><h4>We Believe In</h4>
    </div>
    <br></br>


    <div className='text-center' id="found-subhead"><h5>"Our mission is to empower humanity to be self reliant and live with dignity"</h5>
    </div>
    <br></br>


     <div className='found-para'><p1>"Making a difference". That's the mantra by which we operate. We believe that through our actions if we enhance even one person's life then our goal has been achieved. 'We are the most fortunate' and with that understanding we serve the less fortunate by providing support in any form or shape possible.</p1>
     </div>
     <br></br>
     <br></br>
     <br></br>
     <br></br>
     

     <div className='text-center'><h4>Our Events</h4>
    </div>
    <Foundationcarousel/>




     </div>
     

  )
}
export default FoundationdashboardMain